import { Mail, Video, Phone } from "lucide-react";

const crisisNumbers = [
  { name: "Emergency Services", number: "000", href: "tel:000" },
  { name: "Lifeline", number: "13 11 14", href: "tel:131114" },
  { name: "Beyond Blue", number: "1300 22 4636", href: "tel:1300224636" },
  { name: "1800RESPECT", number: "1800 737 732", href: "tel:1800737732" },
];

const Contact = () => {
  return (
    <div data-testid="contact-page">
      {/* Intro */}
      <section
        className="border-b"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg)",
        }}
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p
            className="text-sm md:text-base tracking-eyebrow uppercase mb-6"
            style={{ color: "var(--mc-muted)" }}
          >
            Contact
          </p>
          <h1
            className="font-serif-display text-2xl md:text-3xl lg:text-4xl leading-[1.15] max-w-3xl"
            style={{ color: "var(--mc-ink)" }}
            data-testid="contact-heading"
          >
            Begin where you are.
          </h1>
          <p
            className="mt-10 text-lg md:text-xl leading-relaxed max-w-2xl font-light"
            style={{ color: "var(--mc-ink-2)" }}
          >
            If you’re considering counselling or therapy, an initial
            conversation is an opportunity to explore whether working together
            feels like the right fit.
          </p>
        </div>
      </section>

      {/* Fees */}
      <section
        style={{ backgroundColor: "var(--mc-bg-2)" }}
        data-testid="fees-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-5"
              style={{ color: "var(--mc-muted)" }}
            >
              Fees
            </p>
            <h2
              className="font-serif-display text-3xl md:text-4xl leading-snug"
              style={{ color: "var(--mc-ink)" }}
            >
              Transparent, accessible, &amp; aligned to you.
            </h2>
          </div>

          <div className="md:col-span-8 space-y-10">
            <div
              className="pb-10 border-b"
              style={{ borderColor: "var(--mc-border)" }}
              data-testid="fee-consultation"
            >
              <p
                className="text-sm md:text-base tracking-eyebrow uppercase mb-2"
                style={{ color: "var(--mc-muted)" }}
              >
                Free Initial Consultation
              </p>
              <h3
                className="font-serif-display text-3xl md:text-4xl"
                style={{ color: "var(--mc-ink)" }}
              >
                15 minutes —{" "}
                <em style={{ color: "var(--mc-terracotta)" }}>complimentary</em>
              </h3>
              <p
                className="mt-4 text-base md:text-lg leading-relaxed max-w-2xl font-light"
                style={{ color: "var(--mc-ink-2)" }}
              >
                A brief introductory phone conversation to discuss your needs,
                answer questions, and explore whether working together feels
                like a good fit.
              </p>
            </div>

            <div data-testid="fee-session">
              <p
                className="text-sm md:text-base tracking-eyebrow uppercase mb-2"
                style={{ color: "var(--mc-muted)" }}
              >
                Counselling &amp; Therapy Session
              </p>
              <h3
                className="font-serif-display text-3xl md:text-4xl"
                style={{ color: "var(--mc-ink)" }}
              >
                60 minutes — <span className="tabular-nums">$80 AUD</span>
              </h3>
              <p
                className="mt-4 text-base md:text-lg leading-relaxed max-w-2xl font-light"
                style={{ color: "var(--mc-ink-2)" }}
              >
                Online via Zoom. Please get in touch if cost is a barrier to
                accessing support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Direct contact */}
      <section
        className="border-t"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg)",
        }}
        data-testid="direct-contact-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p
            className="text-sm md:text-base tracking-eyebrow uppercase mb-6"
            style={{ color: "var(--mc-muted)" }}
          >
            Contact Carl Maxfield
          </p>
          <h2
            className="font-serif-display text-3xl md:text-5xl leading-tight mb-14 max-w-3xl"
            style={{ color: "var(--mc-ink)" }}
          >
            For more information about counselling and therapy, please get in
            touch.
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
            <a
              href="tel:+61438350547"
              className="group flex items-start gap-5 p-8 rounded-[1.5rem] border transition-colors duration-300"
              style={{
                borderColor: "var(--mc-border)",
                backgroundColor: "var(--mc-bg-2)",
              }}
              data-testid="contact-phone-card"
            >
              <span
                className="shrink-0 mt-1 p-3 rounded-full"
                style={{ backgroundColor: "var(--mc-sage)", color: "var(--mc-ink)" }}
              >
                <Phone size={18} />
              </span>
              <span>
                <span
                  className="block text-sm md:text-base tracking-eyebrow uppercase mb-2"
                  style={{ color: "var(--mc-muted)" }}
                >
                  Call or Text
                </span>
                <span
                  className="font-serif-display text-3xl md:text-4xl"
                  style={{ color: "var(--mc-ink)" }}
                >
                  0438 350 547
                </span>
              </span>
            </a>

            <a
              href="mailto:cmaxfield3@hotmail.com"
              className="group flex items-start gap-5 p-8 rounded-[1.5rem] border transition-colors duration-300"
              style={{
                borderColor: "var(--mc-border)",
                backgroundColor: "var(--mc-bg-2)",
              }}
              data-testid="contact-email-card"
            >
              <span
                className="shrink-0 mt-1 p-3 rounded-full"
                style={{ backgroundColor: "var(--mc-sand)", color: "var(--mc-ink)" }}
              >
                <Mail size={18} />
              </span>
              <span>
                <span
                  className="block text-sm md:text-base tracking-eyebrow uppercase mb-2"
                  style={{ color: "var(--mc-muted)" }}
                >
                  Email
                </span>
                <span
                  className="font-serif-display text-2xl md:text-3xl break-all"
                  style={{ color: "var(--mc-ink)" }}
                >
                  cmaxfield3@hotmail.com
                </span>
              </span>
            </a>
          </div>

          <div
            className="mt-16 flex items-start gap-4 max-w-3xl"
            data-testid="online-sessions-note"
          >
            <Video size={20} style={{ color: "var(--mc-muted)" }} className="mt-1 shrink-0" />
            <p
              className="text-base md:text-lg font-light leading-relaxed"
              style={{ color: "var(--mc-ink-2)" }}
            >
              <span className="font-normal" style={{ color: "var(--mc-ink)" }}>
                Online Sessions.
              </span>{" "}
              All sessions are conducted online via Zoom. If we have a session
              booked, I’ll send you a unique Zoom link via email shortly before
              our appointment — simply click on the link to join.
            </p>
          </div>
        </div>
      </section>

      {/* Crisis support */}
      <section
        className="border-t"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg-3)",
        }}
        data-testid="crisis-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-5"
              style={{ color: "var(--mc-muted)" }}
            >
              Crisis Support
            </p>
            <h2
              className="font-serif-display text-3xl md:text-4xl leading-snug mb-6"
              style={{ color: "var(--mc-ink)" }}
            >
              Counselling &amp; therapy are not a crisis service.
            </h2>
            <p
              className="text-base md:text-lg leading-relaxed font-light"
              style={{ color: "var(--mc-ink-2)" }}
            >
              If you are experiencing a crisis or require immediate support,
              please contact emergency services on{" "}
              <a
                href="tel:000"
                className="underline underline-offset-4"
                style={{ color: "var(--mc-ink)" }}
              >
                000
              </a>
              , attend your nearest emergency department, or seek assistance
              from an appropriate healthcare professional.
            </p>
            <p
              className="mt-4 text-sm font-light"
              style={{ color: "var(--mc-muted)" }}
            >
              Please note that service availability may vary.
            </p>
          </div>

          <ul className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {crisisNumbers.map((c) => (
              <li
                key={c.name}
                className="p-6 rounded-[1.25rem] border"
                style={{
                  borderColor: "var(--mc-border)",
                  backgroundColor: "var(--mc-bg)",
                }}
              >
                <a
                  href={c.href}
                  className="block"
                  data-testid={`crisis-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <p
                    className="text-sm md:text-base tracking-eyebrow uppercase mb-2"
                    style={{ color: "var(--mc-muted)" }}
                  >
                    {c.name}
                  </p>
                  <p
                    className="font-serif-display text-2xl md:text-3xl"
                    style={{ color: "var(--mc-ink)" }}
                  >
                    {c.number}
                  </p>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Contact;
